import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { billsStore } from "../stores";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../App";

const useGetAllBills = (billsTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${billsTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${billsTableQuery}&${filterQuery}`;
    } else {
      return billsTableQuery;
    }
  }, [filterQuery, billsTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getAllBills", query],
    queryFn: () => {
      return apiRequest({
        url: `/bills?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const useGetBillsReconciliation = (
  billReconTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${billReconTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${billReconTableQuery}&${filterQuery}`;
    } else {
      return billReconTableQuery;
    }
  }, [filterQuery, billReconTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getBillsReconsiliation", query],
    queryFn: () => {
      return apiRequest({
        url: `/bills/bill-reconcilation?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const getBillsAnalysis = async (query = "") => {
  const { status, errorMessage, data } = await apiRequest({
    url: "/bills/bill-analysis",
    method: "get",
  });

  if (status === constant.Success) {
    billsStore.setBillsAnalysis(data);

    return { status };
  }

  return { status, errorMessage };
};

const getSpecificBillReconciled = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: `/admin/bill-recon`,
    method: "patch",
    payload,
  });

  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getBillsReconsiliation"] });
    return { status };
  }

  return { status, errorMessage };
};

const BillsController = {
  getBillsAnalysis,
  getSpecificBillReconciled,
  useGetAllBills,
  useGetBillsReconciliation,
};

export default BillsController;
